export default {
  namespaced: true,

  state: () => ({
    dataSearch: [],
    isLoading: false,
  }),

  mutations: {
    SET_DATA_SEARCH(state, payload) {
      state.dataSearch = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getDataSearchDistrict({ commit }, { name }) {
      try {
        commit('SET_LOADING', true)

        const url = '/v1/districts'

        const response = await this._vm.$http.get(url, {
          params: {
            query: name,
            limit: 5,
          },
        })

        commit('SET_DATA_SEARCH', response.data.data.rows)
        commit('SET_LOADING', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
  },
}
